import { FaAudioDescription, FaVideo, FaSearch, FaBell, FaDownload, FaClock, FaUserShield, FaLock, FaUsers, FaUniversalAccess, FaPlayCircle, FaPlay, FaSave, FaRedo, FaChartLine, FaEdit, FaCheck, FaCheckCircle, FaChessKing, FaSortAmountUp, FaSortAmountDown, FaStop, FaChevronRight, FaChevronLeft, FaArrowLeft, } from 'react-icons/fa';
import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Dropdown, Alert } from 'react-bootstrap';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import 'react-quill/dist/quill.snow.css'; // Quill styles
import moment from 'moment';
import axios from 'axios';
import Produit from '../../produit/accueil';

const ConfigurerGroupe = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });

    const user_id = localStorage.getItem('IDDDD');
    const { groupe_id } = location.state || {};

    const [donnees_utilisateur, setDonnees_utilisateur] = useState([]);
    const [activeSection, setActiveSection] = useState('infos'); // Nouveau state pour gérer les sections
    const [groupeData, setGroupeData] = useState({});
    const [groupeUsers, setGroupeUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedGroupeUsers, setSelectedGroupeUsers] = useState([]);
    const [selectedAllUsers, setSelectedAllUsers] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [searchGroupe, setSearchGroupe] = useState('');
    const [searchAll, setSearchAll] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [groupeAcces, setGroupeAcces] = useState(null);
    const [selectUtilisateurs, setSelectUtilisateurs] = useState([]);
    const [delaiSelectionne, setDelaiSelectionne] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    // rechercher sur les etapes parcours et les utilisateurs du parcours
    const [searchEtape, setSearchEtape] = useState('');
    const [searchUtilisateur, setSearchUtilisateur] = useState('');


    const [listeEtape, setListeEtape] = useState([]);
    const [listeDetailEtapeUtilisateurs, setListeDetailEtapeUtilisateurs] = useState([]);

    const [userData, setUserData] = useState([]);


    const [searchCoach, setSearchCoach] = useState(""); // Recherche dans les coachs disponibles
    const [selectedAvailableCoaches, setSelectedAvailableCoaches] = useState([]); // Coachs sélectionnés (disponibles)

    const [searchGroupCoach, setSearchGroupCoach] = useState(""); // Recherche dans les coachs assignés
    const [selectedGroupCoaches, setSelectedGroupCoaches] = useState([]); // Coachs sélectionnés (assignés)
    const [groupCoaches, setGroupCoaches] = useState([]); // Coachs assignés au groupe
    const [filteredAvailableCoaches, setFilteredAvailableCoaches] = useState([]); // Coachs disponibles
    const [parcoursModal, setParcoursModal] = useState(false);

    // Filtrer les Coachs en fonction de la recherche
    const filteredGroupeCoach = groupCoaches.filter(coach =>
        `${coach.nom} ${coach.prenoms}`.toLowerCase().includes(searchGroupCoach.toLowerCase())
    );

    const filteredAllCoachs = filteredAvailableCoaches.filter(coach =>
        `${coach.nom} ${coach.prenoms}`.toLowerCase().includes(searchCoach.toLowerCase())
    );


    const handleOuvrirParcoursModal = () => setParcoursModal(true);
    const handleFermerParcoursModal = () => setParcoursModal(false);


    const handleAssignerCoach = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_HOTE}/assigner-coach/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        coachs: selectedAvailableCoaches,
                        groupe_id: groupe_id
                    }
                ),
            });
            const result = await response.json();

            if (response.ok) {
                showAlert('Les coachs ont été assignés avec succès.');
                fetchGroupeData();
                fetchCoaches();
            } else {
                showAlert(result.error || 'Erreur lors de l\'assignation des coachs.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur est survenue.');
        }
    };

    const handleDesassignerCoach = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_HOTE}/desassigner-coach/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        coachs: selectedGroupCoaches,
                        groupe_id: groupe_id
                    }
                ),
            });
            const result = await response.json();

            if (response.ok) {
                showAlert('Les coachs ont été desassignés avec succès.');
                fetchGroupeData();
                fetchCoaches();
            } else {
                showAlert(result.error || 'Erreur lors de l\'assignation des coachs.');
            }
        } catch (error) {
            showAlert('Une erreur est survenue.', error);
        }
    };

    const dropdownStyles = {
        height: '320px',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        backgroundColor: '#f9f9f9',
        color: '#333',
        fontSize: '16px',
        marginBottom: '20px',
    };

    const fetchCoaches = async (groupeId) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-coachs-groupe/${groupe_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ groupe_id: groupeId }),
            });

            if (response.ok) {
                const data = await response.json();
                setGroupCoaches(data.coachs_dans_groupe);
                setFilteredAvailableCoaches(data.coachs_hors_groupe);
            } else {
                console.error("Erreur lors de la récupération des coachs :", await response.text());
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        }
    };
    useEffect(() => {
        if (groupe_id) {
            fetchCoaches();
        }
    }, [groupe_id]);


    useEffect(() => {
        setIsLoadingGlobale(true)
        const fetchUserData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                setIsLoadingGlobale(false)
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        fetchUserData();
    }, [user_id]);


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };


    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    const navigate = useNavigate();

    const showAlert = (message, type = 'success') => {
        fetchEtapeData()
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 10000);
    };


    const fetchGroupeData = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-info/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeData(data);
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données du groupe', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {

        fetchGroupeData();
    }, [groupe_id]);


    const fetchUsers = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/afficher-utilisateurs-du-groupe/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeUsers(data.utilisateurs_du_groupe);
                setAllUsers(data.tous_utilisateurs);
            } else {
                console.error('Erreur lors de la récupération des utilisateurs');
            }
        } catch (error) {
            console.error('Erreur:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [groupe_id]);

    const ajouterTous = () => {
        setGroupeUsers([...groupeUsers, ...allUsers]);
        setAllUsers([]);
    };

    const ajouterSelection = () => {
        const selectedUsers = allUsers.filter(user => selectedAllUsers.includes(user.id));
        setGroupeUsers([...groupeUsers, ...selectedUsers]);
        setAllUsers(allUsers.filter(user => !selectedAllUsers.includes(user.id)));
        setSelectedAllUsers([]);
    };

    const retirerSelection = () => {
        const selectedUsers = groupeUsers.filter(user => selectedGroupeUsers.includes(user.id));
        setAllUsers([...allUsers, ...selectedUsers]);
        setGroupeUsers(groupeUsers.filter(user => !selectedGroupeUsers.includes(user.id)));
        setSelectedGroupeUsers([]);
    };

    const retirerTous = () => {
        setAllUsers([...allUsers, ...groupeUsers]);
        setGroupeUsers([]);
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-utilisateurs-groupe/${groupe_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utilisateurs_ids: groupeUsers.map(user => user.id)
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                fetchGroupeData();
                showAlert(errorData);

            } else {
                const responseData = await response.json();
                showAlert('Configuration faite avec succès.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Erreur lors de l\'enregistrement des utilisateurs.');
        }
    };

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Configurer Groupe";
        }
    }, [user_id]);

    const filteredGroupeUsers = groupeUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchGroupe.toLowerCase())
    );

    const filteredAllUsers = allUsers.filter(user =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(searchAll.toLowerCase())
    );

    const handleDefineAccess = () => {
        if (groupe_id) {
            fetchGroupeAcces(groupe_id);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => setShowModal(false);



    const [recherche, setRecherche] = useState(""); // État pour le terme de recherche

    // Fonction pour gérer le changement dans le champ de recherche
    const handleRechercherChange = (e) => {
        setRecherche(e.target.value);
    };

    // Filtrer les utilisateurs en fonction de la recherche
    const filtreUtilisateurs = groupeUsers.filter((user) =>
        `${user.nom} ${user.prenoms}`.toLowerCase().includes(recherche.toLowerCase())
    );

    useEffect(() => {
        const initialSelected = groupeUsers
            .filter((user) => user.qcm === 'oui') // Inclure seulement les utilisateurs avec qcm="oui"
            .map((user) => user.id);
        setSelectUtilisateurs(initialSelected);
    }, [groupeUsers]);



    // Gère la sélection individuelle
    const handleCheckboxChange = (userId) => {
        setSelectUtilisateurs((prevSelected) => {
            // Si l'utilisateur est déjà sélectionné, on le retire, sinon on l'ajoute
            if (prevSelected.includes(userId)) {
                return prevSelected.filter(id => id !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    const handleDelaiChange = (e) => {
        const newDelai = e.target.value;
        setDelaiSelectionne(newDelai);
    };


    // Gère la sélection/désélection de tous les utilisateurs
    const handleSelectTous = () => {
        if (selectUtilisateurs.length === groupeUsers.length) {
            setSelectUtilisateurs([]); // Tout désélectionner
        } else {
            setSelectUtilisateurs(groupeUsers.map((user) => user.id)); // Tout sélectionner
        }
    };

    const handleEnregistrer = async () => {
        try {
            // Construire la liste des utilisateurs avec leurs valeurs "oui" ou "non"
            const utilisateursStatuts = groupeUsers.map((user) => ({
                id: user.id,
                statutqcm: selectUtilisateurs.includes(user.id) ? 'oui' : 'non',
            }));

            const countOui = utilisateursStatuts.filter(user => user.statutqcm === 'oui').length;

            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-statut-qcm-utilisateur/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    groupeId: groupe_id,
                    utilisateurs: utilisateursStatuts,
                    // delai: delaiSelectionne,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                showAlert("Configuration enregistrée avec succès");
                fetchGroupeData()
                fetchUsers()
            } else {
                const errorData = await response.json();
                console.error('Erreur:', errorData.error);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };




    useEffect(() => {
        if (groupeUsers.length > 0) {

            // Sélectionner les utilisateurs avec qcm_journalier = 'oui'
            const utilisateursSelectionnes = groupeUsers
                .filter(user => user.qcm_journalier === 'oui')
                .map(user => user.id);


            // Mettre à jour l'état selectUtilisateurs
            setSelectUtilisateurs(utilisateursSelectionnes);
        }
    }, [groupeUsers]);


    const handleReinitialiser = async () => {
        try {
            setIsLoading(true); // Activer l'indicateur de chargement

            const response = await fetch(process.env.REACT_APP_HOTE + `/reinitialiser-statut-groupe-et-utilisateurs/${groupe_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                showAlert("Le groupe a été réinitialisé avec succès !");
                fetchGroupeData()
                fetchUsers()
            } else {
                const error = await response.json();
                console.error("Erreur lors de la réinitialisation :", error.message);
                showAlert("Échec de la réinitialisation : " + error.message);
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
            showAlert("Une erreur est survenue lors de la réinitialisation.");
        } finally {
            setIsLoading(false); // Désactiver l'indicateur de chargement
        }
    }


    const [originalGroupeData, setOriginalGroupeData] = useState({});

    const handleModifier = async (event) => {
        event.preventDefault();
        const formData = {
            nom: groupeData.nom,
            description: groupeData.description,
            type_groupe: groupeData.type_groupe
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-groupe/${groupe_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                showAlert('Modification éffectuée avec succès');
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };



    const handleDemarrerQcm = async () => {
        if (groupe_id) {

            if (!delaiSelectionne) {
                showAlert('Veuillez sélectionner le délai.', 'danger')
                return;
            }
            setIsLoading(true);
            try {

                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/enregistrer-qcm-journalier/${groupe_id}/`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            delai: delaiSelectionne,
                        }),
                    }
                );

                if (response.ok) {
                    showAlert(`Lancement des QCMs journaliers !`);
                    fetchGroupeData()
                    fetchUsers()
                } else {
                    const data = await response.json();
                    console.error('Erreur lors de la tentative de démarrage des QCMs.', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false); // Désactive le loader après traitement
            }
        }
    };


    const handlePauseQcm = async () => {
        if (groupe_id) {
            setIsLoading(true); // Affiche le loader sur le bouton
            try {

                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/mettre-pause-qcm-journalier/${groupe_id}/`,
                    {
                        method: 'OPTIONS',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );

                if (response.ok) {
                    showAlert(`QCMs journaliers mis en pause !`);
                    fetchGroupeData()
                    fetchUsers()
                } else {
                    const data = await response.json();
                    console.error('Erreur lors de la tentative de mise en pause des QCMs.', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false); // Désactive le loader après traitement
            }
        }
    };


    const [parcours, setParcours] = useState([]);

    const fetchParcours = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours-dispo/');
            if (response.ok) {
                const data = await response.json();

                // Liste des IDs à exclure
                const parcoursIdsToExclude = Object.values(listeEtape).map(item => item.parcour_id);

                // Filtrer les parcours pour exclure ceux dont l'ID est dans parcoursIdsToExclude
                const filteredData = data.filter(parcoursItem => !parcoursIdsToExclude.includes(parcoursItem.id));

                setParcours(filteredData);
            } else {
                console.error('Erreur lors de la récupération des parcours');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        if (Object.keys(listeEtape).length > 0 || Object.keys(listeEtape).length === 0) {
            fetchParcours();
        }
    }, [listeEtape]);




    


    const [acces, setAcces] = useState({
        Accueil: false,
        Boutique: false,
        Utilisateurs: false,
        Administration: false,
        Produits: false,
        Groupes: false,
        Produit: false,
        ListeDeDiffusion: false,
        Transactions: false,
        Transaction: false,
    });

    // Initialiser les accès en fonction de groupeAcces
    useEffect(() => {
        if (groupeAcces && Array.isArray(groupeAcces) && groupeAcces.length > 0) {
            // Récupérer la chaîne acces du premier élément
            const accesString = groupeAcces[0].acces;

            try {
                // Corriger les apostrophes et parser en tableau
                const accesArray = JSON.parse(accesString.replace(/'/g, '"'));

                const newAcces = {
                    Accueil: accesArray.includes('Accueil'),
                    Boutique: accesArray.includes('Boutique'),
                    Utilisateurs: accesArray.includes('Utilisateurs'),
                    Administration: accesArray.includes('Administration'),
                    Produits: accesArray.includes('Produits'),
                    Categories: accesArray.includes('Categories'),
                    Groupes: accesArray.includes('Groupes'),
                    Produit: accesArray.includes('Produit'),
                    ListeDeDiffusion: accesArray.includes('ListeDeDiffusion'),
                    Transactions: accesArray.includes('Transactions'),
                    Transaction: accesArray.includes('Transaction'),
                };

                setAcces(newAcces);
            } catch (error) {
                console.error("Erreur lors du parsing de l'accès :", error);
            }
        } else {
            console.log("Format de groupeAcces invalide ou accès non défini.");
            console.log('aceessssss',groupeAcces)

            const newAcces = {
                Accueil: false,
                Boutique: false,
                Utilisateurs: false,
                Administration: false,
                Produits: false,
                Categories: false,
                Groupes: false,
                Produit: false,
                Maintenance: false,
                ListeDeDiffusion: false,
                Transactions: false,
                Transaction: false,
            };

            setAcces(newAcces);
        }
    }, [groupeAcces]);


    const handleCheckboxAccesChange = (e) => {
        const { name, checked } = e.target;
        setAcces((prevAcces) => ({
            ...prevAcces,
            [name]: checked,
        }));
    };

    const generateAccesArray = () => {
        return Object.keys(acces).filter(key => acces[key]); // Retourner le tableau des accès
    };

    const handleSave = () => {
        const accesArray = generateAccesArray();
        handleAccesChange(accesArray); // Envoyer le tableau au parent
        // handleClose(); // Fermer le modal après l'enregistrement
    };

    const handleAccesChange = async (accesString) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-acces-groupe/${groupe_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ acces: accesString }),
            });

            if (response.ok) {
                const responseData = await response.json();

                showAlert('Accès enregistrés avec succès !');
            } else {
                const errorData = await response.json();
                console.error('Erreur lors de l\'enregistrement des accès:', errorData);
            }

        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeAcces = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-acces/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeAcces(data.acces);
                console.log('aceessssss22222222',data.acces)
            } else {
                console.error('Erreur lors de la récupération des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    
    useEffect(() => {
        if (user_id) {
            fetchGroupeAcces();
        }
    }, []);

   
    const fetchEtapeData = async () => {
        try {
            // console.log(groupeData.parcours);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-etape-groupe/${groupe_id}/`);
            if (response.ok) {
                const data = await response.json();
                setListeEtape(data);
                fetchGroupeData();
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données du parcours. Code:', data);
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    const fetchDetailEtapeUtilisateursData = async (etape_id, parcour_id) => {
        try {
            // console.log(groupeData.parcours);
            const response = await fetch(`${process.env.REACT_APP_HOTE}/chercher-details-etape-utilisateurs/${groupe_id}/${parcour_id}/${etape_id}/`);
            if (response.ok) {
                const data = await response.json();
                console.log(data.resultats)
                setListeDetailEtapeUtilisateurs(data.resultats);
                fetchGroupeData();
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des données. Code:', data);
                fetchGroupeData();
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const [detailsEtapeUtilisateursModal, setDetailsEtapeUtilisateursModal] = useState(false);

    const handleAfficherDetailsEtapeUtilisateursModal = (etape_id, parcour_id) => {
        setDetailsEtapeUtilisateursModal(true);
        // console.log(etape_id)
        fetchDetailEtapeUtilisateursData(etape_id, parcour_id);
    };
    const handleFermerDetailsEtapeUtilisateursModal = () => setDetailsEtapeUtilisateursModal(false);


    const [pageCourante, setPageCourante] = useState(1);
    const nombreItemsParPage = 10;

    // Calculer les éléments à afficher pour la page actuelle
    const indexDernierItem = pageCourante * nombreItemsParPage;
    const indexPremierItem = indexDernierItem - nombreItemsParPage;
    const itemsPageCourante = listeDetailEtapeUtilisateurs.slice(indexPremierItem, indexDernierItem);

    // Gérer le changement de page
    const changerPage = (numeroPage) => setPageCourante(numeroPage);

    // Calculer le nombre total de pages
    const totalPage = Math.ceil(listeDetailEtapeUtilisateurs.length / nombreItemsParPage);

    // Créer des numéros de page
    const numerosDePage = [];
    for (let i = 1; i <= totalPage; i++) {
        numerosDePage.push(i);
    }



    useEffect(() => {
        fetchEtapeData();
        fetchGroupeData();
    }, []);


    const terminerEtape = async (etape, parcours_id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/terminer-etape/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    groupe_id: groupe_id,
                    parcours_id: parcours_id,
                    etape_id: etape.id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showAlert('Etape terminée.');
                fetchEtapeData();
            } else {
                showAlert(data.error || 'Erreur lors de la mise à jour.');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur s\'est produite.');
        }
    };



    const filteredParcours = parcours.filter(parcours =>
        parcours.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parcours.nbre_heure.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort Parcourss
    const sortedParcours = [...filteredParcours].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });


    const [currentPageParcours, setCurrentPageParcours] = useState(1);
    const [itemsParPageParcours, setItemsParPageParcours] = useState(10);
    const totalItemsParcours = parcours.length;
    const totalPagesParcours = Math.ceil(parcours.length / itemsParPageParcours);
    const [searchTermParcours, setSearchTermParcours] = useState('');
    const handleItemsParPageChange = (e) => {
        setItemsParPageParcours(Number(e.target.value));
        setCurrentPageParcours(1);
    };


    const indexOfLastFormation = currentPageParcours * itemsParPageParcours;
    const indexOfFirstFormation = indexOfLastFormation - itemsParPageParcours;
    const currentParcours = sortedParcours.slice(indexOfFirstFormation, indexOfLastFormation);
    const totalPages = Math.ceil(sortedParcours.length / itemsParPageParcours);




    const [etapesUtilisateur, setEtapesUtilisateur] = useState([]);
    const [utilisateurNom, setUtilisateurNom] = useState("");
    const [utilisateurId, setUtilisateurId] = useState("");
    const [cleParcours, setCleParcours] = useState("");

    const [progressionParUtilisateur, setProgressionParUtilisateur] = useState(false);
    const handleOuvrirProgressionParUtilisateur = (fichierParcours, nomComplet, utilisateur_id, parcoursKey) => {
        setEtapesUtilisateur(fichierParcours);
        setUtilisateurNom(nomComplet);
        setUtilisateurId(utilisateur_id);
        setCleParcours(parcoursKey);
        setProgressionParUtilisateur(true);
    };
    const handleFermerProgressionParUtilisateur = () => {
        setProgressionParUtilisateur(false);
        setAfficherDetail(false);
        setEtapesUtilisateur([]);
        setEvaluation(null);
        setEtapeSelectionne('');
    };

    const [afficherDetail, setAfficherDetail] = useState(false);
    const [etapeSelectionne, setEtapeSelectionne] = useState(null);
    const handleVoirClick = (etape) => {
        setEtapeSelectionne(etape);
        setAfficherDetail(true);
    };


    const [evaluation, setEvaluation] = useState([]);

    const [isLoadingEvaluation, setIsLoadingEvaluation] = useState(true);

    useEffect(() => {
        const fetchEvaluation = async () => {
            setIsLoadingEvaluation(true); // Commencer le chargement
            try {
                const url = new URL(process.env.REACT_APP_HOTE + `/historique/${utilisateurId}/${etapeSelectionne?.id}/${cleParcours}/`);

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();
                if (response.ok) {
                    // Filtrer les évaluations pour inclure uniquement celles avec des QCM où `reponse` n'est pas vide
                    const filteredEvaluations = (data.qcms || []).map((evaluation) => {
                        return {
                            ...evaluation,
                            qcm: evaluation.qcm.filter((qcm) => qcm.resultat && qcm.resultat.length > 0)
                        };
                    }).filter((evaluation) => evaluation.qcm.length > 0);

                    setEvaluation(filteredEvaluations); // Mettre à jour l'état avec les QCM filtrés
                    console.log('QCM filtrés:', filteredEvaluations);
                } else {
                    console.log(etapeSelectionne);
                    console.log("Erreur lors de la récupération des données de l'évaluation", data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoadingEvaluation(false); // Terminer le chargement
            }
        };

        fetchEvaluation();
    }, [utilisateurId, etapeSelectionne?.id, cleParcours]);


    // Gérer l'état des évaluations ouvertes/fermées
    const [openEvaluations, setOpenEvaluations] = useState({});

    // Fonction pour gérer le clic sur une évaluation
    const toggleEvaluation = (evaluationId) => {
        setOpenEvaluations((prev) => ({
            ...prev,
            [evaluationId]: !prev[evaluationId], // Bascule entre ouvert/fermé
        }));
    };


    const handleRetour = () => {
        setAfficherDetail(false); // Revenir à la liste principale
        setEtapeSelectionne(null);
    };

    const handleRetourSurEveluation = () => {
        setSelectedEvaluation(null); // Réinitialiser l'évaluation sélectionnée
    };

    const [selectedEvaluation, setSelectedEvaluation] = useState(null);

    const selectEvaluation = (evaluationId) => {
        setSelectedEvaluation(evaluationId === selectedEvaluation ? null : evaluationId);
    };



    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Groupes")) {
        return null;
    }



    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' />Configurer Groupe</h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}>Groupes</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <span>{groupeData.nom} / Configurer Groupe </span>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>


                    {alert.message && (
                        <div className={`alert mt-3 alert-${alert.type}`} role="alert"
                            dangerouslySetInnerHTML={{ __html: alert.message }} />
                    )}

                    <div className="container-fluid">
                        <div className="container mt-3 mb-5">
                            <div className="row">
                                <div className="col-md-3 ibox-content border-end mr-4 ml-4" style={{ borderRadius: "15px" }}>
                                    <div className="btn-group-vertical w-100 text-start">
                                        <button
                                            className={`btn text-start py-2 d-flex align-items-center ${activeSection === 'infos' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('infos')}
                                        >
                                            <FaUserShield className="me-2 ml-2 mr-2" />
                                            <span>Infos</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'acces' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('acces')}
                                        >
                                            <FaUniversalAccess className="me-2 ml-2 mr-2" />
                                            <span>Accès</span>
                                        </button>
                                        <button
                                            className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'membres' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                            onClick={() => setActiveSection('membres')}
                                        >
                                            <FaUsers className="me-2 ml-2 mr-2" />
                                            <span>Membres ({groupeUsers.length || '0'})</span>
                                        </button>
                                        {/* {(!userData.coach_groupe || userData.coach_groupe === "") && ( // Affiche cette section uniquement si coach_groupe est vide
                                            <button
                                                className={`btn text-start mt-2 py-2 d-flex align-items-center ${activeSection === 'coach' ? 'bg-light text-dark border border-secondary fw-bold' : 'btn-light'}`}
                                                onClick={() => setActiveSection('coach')}
                                            >
                                                <FaChessKing className="me-2 ml-2 mr-2" />
                                                <span>Coach ({groupCoaches.length || '0'})</span>
                                            </button>
                                        )} */}
                                       
                                    </div>
                                </div>

                                {!isLoadingGlobale ? (

                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        {activeSection === 'infos' && (
                                            <div className=''>
                                                <div className="ibox-title">
                                                    <h4>Modifier le groupe</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <form className="m-t" role="form" encType="multipart/form-data">
                                                        {/* Formulaire pour le nom */}
                                                        <div className="form-group">
                                                            <label>Nom*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="nom"
                                                                value={groupeData.nom || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, nom: e.target.value })}
                                                            />
                                                        </div>

                                                        {/* Formulaire pour la description avec Quill */}
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                name="description"
                                                                value={groupeData.description || ''}
                                                                onChange={(e) => setGroupeData({ ...groupeData, description: e.target.value })}
                                                            />
                                                        </div>

                                                        {/* Sélecteur pour le statut */}
                                                        {(!userData.coach_groupe || userData.coach_groupe === "") && (
                                                            <div className="form-group">
                                                                <label>Type du groupe*</label>
                                                                <select
                                                                    className="form-control m-b"
                                                                    name="type_groupe"
                                                                    value={groupeData.type_groupe}
                                                                    onChange={(e) => setGroupeData({ ...groupeData, type_groupe: e.target.value })}
                                                                >
                                                                    <option value="Cohorte">Cohorte</option>
                                                                    <option value="Groupe système">Groupe système</option>
                                                                </select>
                                                            </div>
                                                        )}
                                                    </form>
                                                </div>
                                                <div className="text-center mt-4">
                                                    <button type="submit" className="btn btn-success" onClick={handleModifier}>
                                                        Enregistrer
                                                    </button>
                                                </div>
                                            </div>
                                        )}


                                        {activeSection === 'acces' && (
                                            <div className="" key={JSON.stringify(acces)}>
                                                <div className='ibox-title'>
                                                    <h4>Définir les Accès</h4>
                                                </div>
                                                 <div className='ibox-content'>
                                                    {/* Accès Clients
                                                    <div className='mb-4'>
                                                        <h3>Accès Clients</h3>
                                                        <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Accueil"
                                                                        name="Accueil"
                                                                        checked={acces.Accueil}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                    </div> */}


                                                    {/* Accès Gestionnaires */}
                                                    {/* <div className='mb-4'>
                                                        <h3>Accès Gestionnaires</h3>
                                                        <Form className='row mt-3'>
                                                            <div className='col-4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Boutique"
                                                                        name="Boutique"
                                                                        checked={acces.Boutique}
                                                                        onChange={handleCheckboxAccesChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </Form>
                                                    </div> */}

                                                    {/* Accès Administrateurs */}
                                                    {(!userData.coach_groupe || userData.coach_groupe === "") && ( // Affiche cette section uniquement si coach_groupe est vide
                                                        <div>
                                                            <h3>Accès Administrateurs</h3>
                                                            <Form className='row mt-3'>
                                                                <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Administration"
                                                                            name="Administration"
                                                                            checked={acces.Administration}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Utilisateurs"
                                                                            name="Utilisateurs"
                                                                            checked={acces.Utilisateurs}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                 <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Groupes"
                                                                            name="Groupes"
                                                                            checked={acces.Groupes}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                
                                                                
                                                               
                                                            </Form>

                                                            <Form className='row mt-3'>

                                                                <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Produits"
                                                                            name="Produits"
                                                                            checked={acces.Produits}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Categories"
                                                                            name="Categories"
                                                                            checked={acces.Categories}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label="Transactions"
                                                                            name="Transactions"
                                                                            checked={acces.Transactions}
                                                                            onChange={handleCheckboxAccesChange}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </Form>

                                                        </div>
                                                    )}
                                                </div>



                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Button variant="success" onClick={handleSave}>
                                                        Enregistrer
                                                    </Button>
                                                </div>
                                            </div>
                                        )}

                                    

                                        {activeSection === 'membres' && (
                                            <div>
                                                <div className='ibox-title'>
                                                    <h4>Gérer les membres du groupe</h4>
                                                </div>
                                                <div className='ibox-content'>

                                                    {/* Liste des utilisateurs déjà ajoutés au groupe */}
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    // type="text"
                                                                    // className="form-control"
                                                                    // placeholder="Rechercher..."
                                                                    // value={searchGroupe}
                                                                    // onChange={(e) => setSearchGroupe(e.target.value)}
                                                                    type="text"
                                                                    placeholder="Rechercher..."
                                                                    value={searchAll}
                                                                    onChange={(e) => setSearchAll(e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs disponibles</h5>
                                                            <select
                                                                multiple
                                                                value={selectedAllUsers}
                                                                onChange={(e) => setSelectedAllUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredAllUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Boutons d'actions pour ajouter ou retirer des utilisateurs */}
                                                        <div className="col-md-4 d-flex flex-column justify-content-center">
                                                            <button onClick={ajouterTous} className="btn btn-dark mb-2">
                                                                {"Ajouter tous >>"}
                                                            </button>
                                                            <button onClick={ajouterSelection} className="btn btn-dark mb-2">
                                                                {"Ajouter sélection >"}
                                                            </button>
                                                            <button onClick={retirerSelection} className="btn btn-dark mb-2">
                                                                {"< Retirer sélection"}
                                                            </button>
                                                            <button onClick={retirerTous} className="btn btn-dark">
                                                                {"<< Retirer tous"}
                                                            </button>
                                                        </div>

                                                        {/* Liste des utilisateurs disponibles à ajouter */}
                                                        <div className="col-md-4">
                                                            {/* Recherche d'utilisateurs */}
                                                            <div className="d-flex mb-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Rechercher..."
                                                                    value={searchGroupe}
                                                                    onChange={(e) => setSearchGroupe(e.target.value)}
                                                                />
                                                            </div>
                                                            <h5>Utilisateurs du groupe</h5>
                                                            <select
                                                                multiple
                                                                value={selectedGroupeUsers}
                                                                onChange={(e) => setSelectedGroupeUsers([...e.target.selectedOptions].map(option => parseInt(option.value)))}
                                                                className="form-control"
                                                                style={{
                                                                    height: '320px',
                                                                    padding: '10px',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc',
                                                                    backgroundColor: '#f9f9f9',
                                                                    color: '#333',
                                                                    fontSize: '16px',
                                                                    marginBottom: '20px',
                                                                }}
                                                            >
                                                                {filteredGroupeUsers.map(user => (
                                                                    <option key={user.id} value={user.id}>
                                                                        {user.nom} {user.prenoms}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* Formulaire pour enregistrer les modifications */}
                                                <div className="text-center mt-4">
                                                    <button onClick={handleSubmit} className="btn btn-success">
                                                        Enregistrer
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="col-md-8 ibox-content" style={{ borderRadius: "15px" }}>
                                        <span
                                            className="spinner-border spinner-border-lg text-success"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    </div>

                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigurerGroupe;
